module.exports = __webpack_public_path__ + "static/media/Email.950245c0.svg";